<template>
    <canvas @click.capture.stop="doNothing" ></canvas>
</template>
<script>

import Chart from 'chart.js';
export default {
	data(){
		return {
			chartEl:'',
			chartOption:{
				tooltips: {
					mode: 'point',
					enabled:true,
					
				},
				legend: {
					onClick:this.click,
				}
			},
			chartData:[],
			clickedIndex:-1,
			clickInfo:[],
		}
	},
	props:{'selectOne':{type:Function},'showDataset':{type:Function}},
	methods:{
		renderChart(chartData){
			chartData = JSON.parse(JSON.stringify(chartData));
			const self = this;
			this.clickedIndex = -1;
			this.chartData = chartData;
			if(chartData && chartData.datasets){
				chartData.datasets.forEach(function(dataset,i){
					dataset.fill = false;
					
					dataset.borderColor = self.getColor(i);
				})
				this.chartEl.data =  chartData;
				this.chartEl.update();
			}
			
		},
		getColor(i){
			const corlors = ['OrangeRed','HotPink','GoldenRod','CadetBlue','LimeGreen','Salmon','SteelBlue','Wheat','Olive','DarkTurquoise'];
			return corlors[i];
		},
		doNothing(){

		},
		// click(e){
		// 	const ds = this.chartEl.getDatasetAtEvent(e);
		// 	if(ds[0]){
		// 		const index = ds[0]['_datasetIndex'];
		// 		const dataset = this.chartData.datasets[index];
		// 		if(e.metaKey || e.ctrlKey){
		// 			this.selectOne(this.chartData.campareBy,dataset.id);
		// 		}else{
		// 			this.showDataset(dataset,this.chartData.labels,this.chartData);
		// 		}
		// 	}
		// },
		click(e,item){
			const chart = this.chartEl;
			const index = item.datasetIndex;
			const dataset = this.chartData.datasets[index];
			if(e.metaKey || e.ctrlKey){
				return this.showDataset(dataset,this.chartData.labels,this.chartData);
			}
			if(this.clickedIndex===index){
				this.chartData.datasets[index].borderColor = this.getColor(index);
				this.selectOne(this.chartData.campareBy,'');
				this.clickedIndex = -1;
			}else{
				if(this.clickedIndex!==-1){
					this.chartData.datasets[this.clickedIndex].borderColor = this.getColor(this.clickedIndex);
				}
				this.chartData.datasets[index].borderColor = '#000000';
				this.selectOne(this.chartData.campareBy,dataset.id);
				this.clickedIndex = index;
			}
			chart.update();
		}

	},
	mounted() {
		const ctx = this.$el.getContext('2d');
		this.chartEl = new Chart(ctx, {
			type: 'line',
			data: [],
			options: this.chartOption
		}),
		this.renderChart({});
	},
	
    
}
</script>
